const __WEBPACK_NAMESPACE_OBJECT__ = window["__MFE_SHARED__"]["react-dom/client"];